exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".co-item{overflow:inherit}.co-item__items-container{display:flex;justify-content:left;align-items:flex-start;flex-grow:1}.co-item__items{width:50%}.co-item-fsl__favourites-image{height:30px;position:relative;cursor:pointer;width:50%;align-self:flex-end}.co-item-fsl__favourites-button{display:inline}.co-item-fsl__divider{border:none;border-bottom:1px solid #ccc}@media (min-width:480px){.co-item{overflow:inherit}.co-item-fsl__favourites-image{height:30px;width:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./shared/interim/product-list/item/_favs.scss
// module id = 851
// module chunks = 0